import './AgentLandingPage.scss';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LandingPageLayout from 'src/components/reusable-components/landing-page-layout';
import { Helpdesk } from 'src/services/apiInterfaces';
import { getAgentHelpdesk } from 'src/services/apiV1';

export default function AgentLandingPage() {
  const { t } = useTranslation('agent-landing-page');
  const [helpdesk, setHelpdesk] = useState<Helpdesk | null>(null);

  useEffect(() => {
    getAgentHelpdesk().then(setHelpdesk).catch(console.error);
  }, []);

  return (
    <LandingPageLayout isAssist>
      <div className='AgentLandingPage-pageContainer'>
        <div className='AgentLandingPage-contentContainer'>
          <div className='AgentLandingPage-contentContainer-inner'>
            <div className='AgentLandingPage-mainTitle'>
              {t('agentLandingPage.title')}
            </div>
            <p className='AgentLandingPage-subTitle'>
              {t('agentLandingPage.subTitle')}
            </p>
            {helpdesk && (
              <a
                className='AgentLandingPage-helpdeskButton'
                href={helpdesk.helpdesk_link}
              >
                {t('agentLandingPage.helpdeskButton', {
                  helpdesk: helpdesk.helpdesk,
                })}
              </a>
            )}
          </div>
        </div>
      </div>
    </LandingPageLayout>
  );
}
